import {SET_EXCEPTION, CLEAR_EXCEPTION, SET_VERIFY_EMAIL, CLEAR_VERIFY_EMAIL} from "src/vuex/mutationTypes";
import apiExceptions from "../../util/valueObjects/apiExceptions";
import { SET_INSERT_PASSWORD, CLEAR_INSERT_PASSWORD } from "../mutationTypes";


const defaultState = {
  id: null,
  verifyEmail: null,
  insertPassword: null,
};
const actions = {
  clearVerifyEmail({commit}){
    commit(CLEAR_VERIFY_EMAIL)
  },
  clearInsertPassword({commit}){
    commit(CLEAR_INSERT_PASSWORD)
  },
  async parseErrorResponse(context, error) {
    if (!error) {
      return;
    }
    if (error.name === apiExceptions.AUTHORIZATION) {
      await this.dispatch("logout");
    }
    if(error.name === apiExceptions.USER_NOT_YET_CREATED){
      await this.dispatch("createTmsUser",'teste1234');
    }
    if(error.name === apiExceptions.VerifyEmailUserException){
      context.commit(SET_VERIFY_EMAIL, false)
    }
    if(error.name === apiExceptions.INSERT_PASSWORD){
      context.commit(SET_INSERT_PASSWORD, false)
    }
    if(error.name === apiExceptions.INVALID_CREDENTIALS){
      await this.dispatch("showInvalidCredentialsModalAction");
    }
  }
};
const mutations = {
  [SET_EXCEPTION]: (state, id) => {
    state.id = id;
  },
  [CLEAR_EXCEPTION]: state => {
    state.id = null;
  },
  [SET_VERIFY_EMAIL]: (state, value) => {
    state.verifyEmail = value;
  },
  [CLEAR_VERIFY_EMAIL]: state => {
    state.verifyEmail = null;
  },
  [SET_INSERT_PASSWORD]: (state, value) => {
    state.insertPassword = value;
  },
  [CLEAR_INSERT_PASSWORD]: state => {
    state.insertPassword = null;
  },
};
const getters = {
  hasException: state => state.id !== null,
  getVerifyEmail: state => state.verifyEmail,
  getInsertPassword: state => state.insertPassword
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
